import {useTranslation} from 'react-i18next';
import './ArrivalOnDevice.scss';
import {useArrivalContext} from 'src/context/ArrivalContext';
import {useEffect, useState} from 'react';
import {ArrivalBookingOnDevice} from './bookingDevice/ArrivalBookingOnDevice';
import {PickSiteLanguage} from '../main/components/PickSiteLanguage';
import {Button} from '../form/button/Button';
import {ArrivalDropInOnDevice} from './dropinDevice/ArrivalDropInOnDevice';

type SelectedTab = 'booking' | 'dropin';

interface ArrivalOnDeviceProps {
    tab: SelectedTab;
}

export function ArrivalOnDevice({tab}: ArrivalOnDeviceProps) {
    const {t} = useTranslation();
    const [selectedTab, setSelectedTab] = useState<SelectedTab>(tab);
    const {dataState} = useArrivalContext();
    const {loading, settings} = dataState;
    const [showNav, setShowNav] = useState(true);

    useEffect(() => {
        document.title = t('route_name.arrival', {clinicName: settings?.name});
    }, [settings, t]);

    function resetAll() {
        document.location.reload();
    }

    if ((!settings && !loading) || (settings && !settings.bookingEnabled && !settings.dropinEnabled)) {
        return (
            <div className='arrival-container__text'>
                <h1>{t('arrival.heading_notfound')}</h1>
            </div>
        );
    }

    return (
        <div className='arrival-on-device-container'>
            <header>
                <button>
                    {settings?.logoUrl && (
                        <img
                            src={settings?.logoUrl}
                            className='arrival-on-device-logo'
                            alt={`${settings?.name} logo`}
                        />
                    )}
                    {!settings?.logoUrl && <h3 className='region-name'>{settings?.name}</h3>}
                </button>
                {showNav && <PickSiteLanguage />}
                {!showNav && (
                    <Button variant='text' onClick={resetAll}>
                        <span>{t('button_cancel.text')}</span>
                    </Button>
                )}
            </header>
            <main className='main-content' id='main'>
                {showNav && (
                    <section>
                        {loading && <span className='skeleton-box'></span>}
                        {!loading && <h1 className='main-content__header'>{t('arrival.heading')}</h1>}
                    </section>
                )}
                {showNav && (
                    <section className='arrival-welcome'>
                        <div className='arrival-welcome__headline'>{settings?.name}</div>
                        {settings?.welcomeText && settings?.welcomeText.length > 0 ? (
                            <p className='wrap-html'>{settings?.welcomeText}</p>
                        ) : (
                            ''
                        )}
                    </section>
                )}
                <div>
                    {showNav && (
                        <nav className={`nav-container`} role='tablist'>
                            {settings?.bookingEnabled && (
                                <button
                                    onClick={() => setSelectedTab('booking')}
                                    type='button'
                                    className={`tab-option ${selectedTab === 'booking' ? 'selected' : ''} `}
                                >
                                    <span>{t('arrival.booking_header')}</span>
                                </button>
                            )}

                            {settings?.dropinEnabled && (
                                <button
                                    onClick={() => setSelectedTab('dropin')}
                                    type='button'
                                    className={`tab-option ${selectedTab === 'dropin' ? 'selected' : ''} `}
                                >
                                    <span>{t('arrival.dropin_header')}</span>
                                </button>
                            )}
                        </nav>
                    )}

                    {selectedTab === 'booking' && settings?.bookingEnabled && (
                        <ArrivalBookingOnDevice setShowNav={setShowNav} />
                    )}

                    {selectedTab === 'dropin' && settings?.dropinEnabled && (
                        <ArrivalDropInOnDevice setShowNav={setShowNav} />
                    )}
                </div>
            </main>
        </div>
    );
}
